{
  "meta": {
    "title": "Four Levels to 73",
    "subject": {
      "sex": "male",
      "dob": "1975-09",
      "heightCm": 179,
      "startWeightKg": 77.3,
      "startBodyFatPct": 18.1,
      "targetWeightKg": 73,
      "targetBodyFatPct": 13,
      "weeks": 16,
      "constraints": [
        "lower back: no deadlifts from the floor, no loaded lumbar flexion, no standing overhead press"
      ],
      "gymAccess": "full commercial gym",
      "runningLevel": "beginner returning"
    },
    "energy": {
      "estimatedMaintenanceKcal": 2400,
      "maintenanceUncertaintyKcal": 200,
      "mifflinBmr": 1642,
      "katchMcArdleBmr": 1737,
      "assumedPal": 1.462,
      "deliveredMeanKcal": 2033,
      "trainingDayMeanKcal": 2122,
      "lighterDayMeanKcal": 1913,
      "meanProteinG": 175,
      "meanFatG": 69,
      "note": "Delivered figures are computed from the meal rotation, not set as targets."
    },
    "scheduleByDow": {
      "0": "liftA",
      "1": "run0",
      "2": "recoveryWed",
      "3": "liftB",
      "4": "run1",
      "5": "run2",
      "6": "recoverySun"
    },
    "deloadWeeks": [
      4,
      8,
      12,
      16
    ],
    "slots": [
      "breakfast",
      "am",
      "lunch",
      "pm",
      "dinner",
      "post"
    ],
    "postSlotDows": [
      0,
      1,
      3,
      5
    ],
    "mealRotationOffsets": {
      "breakfast": 0,
      "am": 2,
      "lunch": 1,
      "pm": 4,
      "dinner": 3,
      "post": 0
    },
    "defaultStartDate": "2026-08-31"
  },
  "trajectory": {
    "weightKg": [
      77.3,
      77.03,
      76.76,
      76.49,
      76.22,
      75.96,
      75.69,
      75.42,
      75.15,
      74.88,
      74.61,
      74.34,
      74.08,
      73.81,
      73.54,
      73.27,
      73
    ],
    "bodyFatPct": [
      18.1,
      17.78,
      17.46,
      17.14,
      16.83,
      16.51,
      16.19,
      15.87,
      15.55,
      15.23,
      14.91,
      14.59,
      14.28,
      13.96,
      13.64,
      13.32,
      13
    ]
  },
  "lifts": {
    "1": {
      "A": {
        "name": "Full Body A",
        "focus": "Learn the patterns. Leave three reps in the tank on every set. Load comes later, and the week 4 gate does not ask for it.",
        "ex": [
          {
            "n": "Goblet squat",
            "s": 3,
            "r": "10",
            "c": "Heels flat, chest tall. RPE 6-7.",
            "m": [
              "quads",
              "glutes"
            ]
          },
          {
            "n": "Dumbbell bench press",
            "s": 3,
            "r": "10",
            "c": "Feet down, ribs down.",
            "m": [
              "chest"
            ]
          },
          {
            "n": "Chest-supported dumbbell row",
            "s": 3,
            "r": "12",
            "c": "The pad takes the load off your back entirely.",
            "m": [
              "rows"
            ]
          },
          {
            "n": "Machine hip thrust",
            "s": 3,
            "r": "12",
            "c": "Ribs down, chin tucked. Finish with glutes, never by arching.",
            "m": [
              "glutes"
            ]
          },
          {
            "n": "Seated calf raise, bent knee",
            "s": 3,
            "r": "15",
            "c": "This is the soleus. It carries the biggest load when you run, which is why calf work is in every single session.",
            "m": [
              "calves"
            ]
          },
          {
            "n": "Lat pulldown, neutral grip",
            "s": 3,
            "r": "12",
            "c": "Pull to the collarbone, pause one second.",
            "m": [
              "lats"
            ]
          },
          {
            "n": "Cable lateral raise",
            "s": 3,
            "r": "15",
            "c": "Both arms, light and strict.",
            "m": [
              "delts"
            ]
          },
          {
            "n": "Pallof press",
            "s": 2,
            "r": "12 each side",
            "c": "Anti-rotation. Your back insurance, and it stays in every phase.",
            "m": [
              "core"
            ]
          }
        ]
      },
      "B": {
        "name": "Full Body B",
        "focus": "Upper emphasis, lighter legs, because Saturday's run is 48 hours away. Match A's effort, not its weight.",
        "ex": [
          {
            "n": "Leg press, depth stop",
            "s": 3,
            "r": "12",
            "c": "Stop roughly 10 degrees short of where your pelvis starts to tuck under. Feet high on the platform. Do not chase depth.",
            "m": [
              "quads"
            ]
          },
          {
            "n": "Incline dumbbell press",
            "s": 3,
            "r": "10",
            "c": "30 degree bench.",
            "m": [
              "chest"
            ]
          },
          {
            "n": "Seated cable row",
            "s": 3,
            "r": "12",
            "c": "Tall torso, no rocking.",
            "m": [
              "rows"
            ]
          },
          {
            "n": "Seated leg curl",
            "s": 4,
            "r": "12",
            "c": "Two seconds down. Hamstring strength protects a runner's knee.",
            "m": [
              "hams"
            ]
          },
          {
            "n": "Standing calf raise",
            "s": 3,
            "r": "15",
            "c": "Straight leg, this one is the gastrocnemius. Pause at the bottom.",
            "m": [
              "calves"
            ]
          },
          {
            "n": "Assisted pull-up",
            "s": 3,
            "r": "8",
            "c": "Pick an assistance level that makes rep 8 genuinely hard, and write down the setting.",
            "m": [
              "lats"
            ]
          },
          {
            "n": "Seated dumbbell shoulder press",
            "s": 3,
            "r": "12",
            "c": "Back supported. Seated for all 16 weeks, no standing variation at any point.",
            "m": [
              "press"
            ]
          },
          {
            "n": "Dead bug",
            "s": 2,
            "r": "10 each side",
            "c": "Lower back glued to the floor. If it lifts, shorten the lever.",
            "m": [
              "core"
            ]
          }
        ]
      }
    },
    "2": {
      "A": {
        "name": "Full Body A",
        "focus": "First real loading block. The last set of the first three exercises should be a genuine effort.",
        "ex": [
          {
            "n": "Hack squat or leg press",
            "s": 4,
            "r": "8-10",
            "c": "Same depth stop as block 1: stop short of where the pelvis tucks. Add 2.5-5kg once you hit the top of the range on every set.",
            "m": [
              "quads",
              "glutes"
            ]
          },
          {
            "n": "Dumbbell bench press",
            "s": 4,
            "r": "8",
            "c": "Add weight when all four sets hit 8.",
            "m": [
              "chest"
            ]
          },
          {
            "n": "Chest-supported dumbbell row",
            "s": 3,
            "r": "10",
            "c": "One second squeeze at the top.",
            "m": [
              "rows"
            ]
          },
          {
            "n": "Barbell or machine hip thrust",
            "s": 3,
            "r": "10",
            "c": "Ribs down at lockout. Do not hyperextend to finish the rep.",
            "m": [
              "glutes"
            ]
          },
          {
            "n": "Seated calf raise, bent knee",
            "s": 3,
            "r": "12",
            "c": "Heavier than block 1.",
            "m": [
              "calves"
            ]
          },
          {
            "n": "Lat pulldown",
            "s": 3,
            "r": "10",
            "c": "",
            "m": [
              "lats"
            ]
          },
          {
            "n": "Cable lateral raise",
            "s": 3,
            "r": "15",
            "c": "",
            "m": [
              "delts"
            ]
          },
          {
            "n": "Pallof press",
            "s": 2,
            "r": "12 each side",
            "c": "",
            "m": [
              "core"
            ]
          }
        ]
      },
      "B": {
        "name": "Full Body B",
        "focus": "Arms enter. Legs stay moderate so Saturday's long run is not compromised.",
        "ex": [
          {
            "n": "Bulgarian split squat",
            "s": 3,
            "r": "10 each leg",
            "c": "Bodyweight the first week, dumbbells after.",
            "m": [
              "quads",
              "glutes"
            ]
          },
          {
            "n": "Seated machine shoulder press",
            "s": 3,
            "r": "10",
            "c": "Back supported.",
            "m": [
              "press"
            ]
          },
          {
            "n": "Seated cable row",
            "s": 3,
            "r": "12",
            "c": "",
            "m": [
              "rows"
            ]
          },
          {
            "n": "Seated leg curl",
            "s": 4,
            "r": "12",
            "c": "",
            "m": [
              "hams"
            ]
          },
          {
            "n": "Standing calf raise",
            "s": 3,
            "r": "12",
            "c": "",
            "m": [
              "calves"
            ]
          },
          {
            "n": "Assisted pull-up",
            "s": 3,
            "r": "8",
            "c": "Reduce the assistance every two weeks and log the setting.",
            "m": [
              "lats"
            ]
          },
          {
            "n": "Superset: rope pushdown and incline curl",
            "s": 3,
            "r": "12 each",
            "c": "No rest between the pair.",
            "m": [
              "arms"
            ]
          },
          {
            "n": "Dead bug",
            "s": 2,
            "r": "12 each side",
            "c": "",
            "m": [
              "core"
            ]
          }
        ]
      }
    },
    "3": {
      "A": {
        "name": "Full Body A",
        "focus": "Heavy top sets. Three ramping sets before the first work set. Full 2-3 minutes rest on the deadlift and the bench.",
        "ex": [
          {
            "n": "Trap-bar deadlift, high handles",
            "s": 4,
            "r": "5",
            "c": "Weeks 9 and 10 at roughly 60 percent effort to groove the pattern. Full working load only from week 11. Stop rule: any symptom that centralises or radiates, or morning stiffness lasting past 30 minutes, means drop 20 percent and re-ramp.",
            "m": [
              "hams",
              "glutes"
            ]
          },
          {
            "n": "Barbell or dumbbell bench press",
            "s": 4,
            "r": "6",
            "c": "Spotter or safety pins.",
            "m": [
              "chest"
            ]
          },
          {
            "n": "Chest-supported dumbbell row",
            "s": 4,
            "r": "8",
            "c": "",
            "m": [
              "rows"
            ]
          },
          {
            "n": "Seated calf raise, bent knee",
            "s": 3,
            "r": "12",
            "c": "",
            "m": [
              "calves"
            ]
          },
          {
            "n": "Lat pulldown or weighted pull-up",
            "s": 4,
            "r": "6",
            "c": "",
            "m": [
              "lats"
            ]
          },
          {
            "n": "Cable lateral raise",
            "s": 3,
            "r": "15",
            "c": "",
            "m": [
              "delts"
            ]
          },
          {
            "n": "Pallof press",
            "s": 2,
            "r": "12 each side",
            "c": "",
            "m": [
              "core"
            ]
          }
        ]
      },
      "B": {
        "name": "Full Body B",
        "focus": "Upper emphasis. Leg work is machine-based so Saturday's long run stays clean.",
        "ex": [
          {
            "n": "Hack squat or leg press, depth stop",
            "s": 4,
            "r": "8",
            "c": "Same depth rule as block 1.",
            "m": [
              "quads"
            ]
          },
          {
            "n": "Seated machine shoulder press",
            "s": 3,
            "r": "8",
            "c": "",
            "m": [
              "press"
            ]
          },
          {
            "n": "Seated cable row",
            "s": 3,
            "r": "12",
            "c": "",
            "m": [
              "rows"
            ]
          },
          {
            "n": "Seated leg curl",
            "s": 3,
            "r": "10",
            "c": "",
            "m": [
              "hams"
            ]
          },
          {
            "n": "Standing calf raise",
            "s": 3,
            "r": "12",
            "c": "",
            "m": [
              "calves"
            ]
          },
          {
            "n": "Assisted or weighted pull-up",
            "s": 4,
            "r": "6",
            "c": "",
            "m": [
              "lats"
            ]
          },
          {
            "n": "Superset: pushdown and hammer curl",
            "s": 3,
            "r": "12 each",
            "c": "",
            "m": [
              "arms"
            ]
          },
          {
            "n": "Dead bug",
            "s": 2,
            "r": "12 each side",
            "c": "",
            "m": [
              "core"
            ]
          }
        ]
      }
    },
    "4": {
      "A": {
        "name": "Full Body A",
        "focus": "Hold the loads. Rest stays full on the deadlift and bench, this is not the session to cut it.",
        "ex": [
          {
            "n": "Trap-bar deadlift, high handles",
            "s": 4,
            "r": "5",
            "c": "Heavy but clean. Stop the set the moment form slips. Three minutes rest.",
            "m": [
              "hams",
              "glutes"
            ]
          },
          {
            "n": "Barbell bench press",
            "s": 4,
            "r": "5",
            "c": "Full rest.",
            "m": [
              "chest"
            ]
          },
          {
            "n": "Chest-supported dumbbell row",
            "s": 3,
            "r": "8",
            "c": "",
            "m": [
              "rows"
            ]
          },
          {
            "n": "Front-foot-elevated split squat",
            "s": 3,
            "r": "8 each leg",
            "c": "25mm plate under the front foot.",
            "m": [
              "quads",
              "glutes"
            ]
          },
          {
            "n": "Seated calf raise, bent knee",
            "s": 3,
            "r": "12",
            "c": "",
            "m": [
              "calves"
            ]
          },
          {
            "n": "Weighted or assisted pull-up",
            "s": 4,
            "r": "5",
            "c": "",
            "m": [
              "lats"
            ]
          },
          {
            "n": "Pallof press",
            "s": 2,
            "r": "12 each side",
            "c": "",
            "m": [
              "core"
            ]
          }
        ]
      },
      "B": {
        "name": "Full Body B",
        "focus": "Density day. 90 seconds rest throughout, this session only. Nothing here is heavy enough for that to be a risk.",
        "ex": [
          {
            "n": "Leg press, depth stop",
            "s": 3,
            "r": "10",
            "c": "",
            "m": [
              "quads"
            ]
          },
          {
            "n": "Seated machine shoulder press",
            "s": 3,
            "r": "8",
            "c": "",
            "m": [
              "press"
            ]
          },
          {
            "n": "Seated cable row",
            "s": 3,
            "r": "12",
            "c": "",
            "m": [
              "rows"
            ]
          },
          {
            "n": "Seated leg curl",
            "s": 3,
            "r": "10",
            "c": "",
            "m": [
              "hams"
            ]
          },
          {
            "n": "Standing calf raise",
            "s": 3,
            "r": "12",
            "c": "",
            "m": [
              "calves"
            ]
          },
          {
            "n": "Lat pulldown",
            "s": 3,
            "r": "10",
            "c": "",
            "m": [
              "lats"
            ]
          },
          {
            "n": "Cable lateral raise",
            "s": 3,
            "r": "15",
            "c": "",
            "m": [
              "delts"
            ]
          },
          {
            "n": "Superset: pushdown and hammer curl",
            "s": 3,
            "r": "12 each",
            "c": "",
            "m": [
              "arms"
            ]
          },
          {
            "n": "Dead bug",
            "s": 2,
            "r": "12 each side",
            "c": "",
            "m": [
              "core"
            ]
          }
        ]
      }
    }
  },
  "runs": {
    "1": [
      {
        "title": "Easy run/walk",
        "blocks": [
          {
            "n": "1 min run / 2 min walk",
            "s": 8,
            "min": 1,
            "c": "Tick a round each time you finish the walk."
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      },
      {
        "title": "Short easy run/walk",
        "blocks": [
          {
            "n": "1 min run / 2 min walk",
            "s": 6,
            "min": 1,
            "c": ""
          }
        ],
        "note": "The short one. Its job is frequency, not fitness."
      },
      {
        "title": "Long easy run/walk",
        "blocks": [
          {
            "n": "1 min run / 2 min walk",
            "s": 9,
            "min": 1,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "2": [
      {
        "title": "Easy run/walk",
        "blocks": [
          {
            "n": "90s run / 2 min walk",
            "s": 7,
            "min": 1.5,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      },
      {
        "title": "Short easy run/walk",
        "blocks": [
          {
            "n": "90s run / 2 min walk",
            "s": 6,
            "min": 1.5,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run/walk",
        "blocks": [
          {
            "n": "90s run / 2 min walk",
            "s": 9,
            "min": 1.5,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "3": [
      {
        "title": "Easy run/walk",
        "blocks": [
          {
            "n": "2 min run / 90s walk",
            "s": 6,
            "min": 2,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      },
      {
        "title": "Short easy run/walk",
        "blocks": [
          {
            "n": "2 min run / 90s walk",
            "s": 5,
            "min": 2,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run/walk",
        "blocks": [
          {
            "n": "2 min run / 90s walk",
            "s": 7,
            "min": 2,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "4": [
      {
        "title": "Easy run/walk",
        "blocks": [
          {
            "n": "2 min run / 90s walk",
            "s": 5,
            "min": 2,
            "c": ""
          }
        ],
        "note": "De-load week. Saturday is the Level 1 test."
      },
      {
        "title": "Short easy run/walk",
        "blocks": [
          {
            "n": "2 min run / 90s walk",
            "s": 4,
            "min": 2,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Level 1 test",
        "blocks": [
          {
            "n": "2 min run / 90s walk",
            "s": 2,
            "min": 2,
            "c": "Warm-up rounds."
          },
          {
            "n": "TEST: 3 min continuous",
            "s": 1,
            "min": 3,
            "c": "No walking. Slow is fine, unbroken is the point."
          }
        ],
        "note": "Take it fresh."
      }
    ],
    "5": [
      {
        "title": "Easy run/walk",
        "blocks": [
          {
            "n": "3 min run / 90s walk",
            "s": 5,
            "min": 3,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      },
      {
        "title": "Short easy run/walk",
        "blocks": [
          {
            "n": "3 min run / 90s walk",
            "s": 4,
            "min": 3,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run/walk",
        "blocks": [
          {
            "n": "3.5 min run / 2 min walk",
            "s": 4,
            "min": 3.5,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "6": [
      {
        "title": "Easy run/walk",
        "blocks": [
          {
            "n": "5 min run / 2 min walk",
            "s": 4,
            "min": 5,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      },
      {
        "title": "Short easy run/walk",
        "blocks": [
          {
            "n": "4 min run / 90s walk",
            "s": 3,
            "min": 4,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run/walk",
        "blocks": [
          {
            "n": "5 min run / 2 min walk",
            "s": 3,
            "min": 5,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "7": [
      {
        "title": "Easy run/walk",
        "blocks": [
          {
            "n": "7.5 min run / 2 min walk",
            "s": 3,
            "min": 7.5,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      },
      {
        "title": "Short easy run/walk",
        "blocks": [
          {
            "n": "5 min run / 90s walk",
            "s": 3,
            "min": 5,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run/walk",
        "blocks": [
          {
            "n": "7.5 min run / 2 min walk",
            "s": 2,
            "min": 7.5,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "8": [
      {
        "title": "Easy run",
        "blocks": [
          {
            "n": "10 min continuous easy",
            "s": 1,
            "min": 10,
            "c": ""
          }
        ],
        "note": "De-load week. Saturday is the Level 2 test."
      },
      {
        "title": "Short easy run/walk",
        "blocks": [
          {
            "n": "4 min run / 90s walk",
            "s": 3,
            "min": 4,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Level 2 test",
        "blocks": [
          {
            "n": "Easy jog warm-up",
            "s": 1,
            "min": 5,
            "c": "Then 3 strides of 20 seconds."
          },
          {
            "n": "TEST: 11 min continuous",
            "s": 1,
            "min": 11,
            "c": "Log the distance. It becomes your baseline."
          }
        ],
        "note": "Take it fresh."
      }
    ],
    "9": [
      {
        "title": "Easy run",
        "blocks": [
          {
            "n": "16 min continuous easy",
            "s": 1,
            "min": 16,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      },
      {
        "title": "Short easy run",
        "blocks": [
          {
            "n": "13 min continuous easy",
            "s": 1,
            "min": 13,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run",
        "blocks": [
          {
            "n": "15 min continuous",
            "s": 1,
            "min": 15,
            "c": ""
          },
          {
            "n": "Walk",
            "s": 1,
            "min": 0,
            "c": "2 minutes."
          },
          {
            "n": "8 min continuous",
            "s": 1,
            "min": 8,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "10": [
      {
        "title": "Easy run",
        "blocks": [
          {
            "n": "18 min continuous easy",
            "s": 1,
            "min": 18,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      },
      {
        "title": "Short easy run",
        "blocks": [
          {
            "n": "13 min continuous easy",
            "s": 1,
            "min": 13,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run",
        "blocks": [
          {
            "n": "22 min continuous easy",
            "s": 1,
            "min": 22,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "11": [
      {
        "title": "Strides and easy",
        "blocks": [
          {
            "n": "Easy running",
            "s": 1,
            "min": 16,
            "c": ""
          },
          {
            "n": "20s stride / 60s walk",
            "s": 5,
            "min": 0.33,
            "c": "Fast but relaxed, not a sprint."
          }
        ],
        "note": "First fast running of the plan. Strides only, no intervals yet."
      },
      {
        "title": "Short easy run",
        "blocks": [
          {
            "n": "14 min continuous easy",
            "s": 1,
            "min": 14,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run",
        "blocks": [
          {
            "n": "25 min continuous easy",
            "s": 1,
            "min": 25,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "12": [
      {
        "title": "Easy run",
        "blocks": [
          {
            "n": "10 min continuous easy",
            "s": 1,
            "min": 10,
            "c": ""
          }
        ],
        "note": "De-load week. Saturday is the Level 3 test."
      },
      {
        "title": "Short easy run",
        "blocks": [
          {
            "n": "8 min continuous easy",
            "s": 1,
            "min": 8,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Level 3 test",
        "blocks": [
          {
            "n": "Easy jog warm-up",
            "s": 1,
            "min": 6,
            "c": "Then 4 strides of 20 seconds."
          },
          {
            "n": "TEST: 30 min continuous",
            "s": 1,
            "min": 30,
            "c": "Roughly 4.5 to 5km. Log the distance."
          }
        ],
        "note": "Take it fresh."
      }
    ],
    "13": [
      {
        "title": "Intervals",
        "blocks": [
          {
            "n": "Easy running",
            "s": 1,
            "min": 8,
            "c": ""
          },
          {
            "n": "1 min hard / 90s easy jog",
            "s": 5,
            "min": 2.5,
            "c": "Hard = you can say three words, not a sentence."
          },
          {
            "n": "Easy running",
            "s": 1,
            "min": 3,
            "c": ""
          }
        ],
        "note": "First real intervals, in week 13 rather than week 9. Your tendons needed the twelve weeks."
      },
      {
        "title": "Short easy run",
        "blocks": [
          {
            "n": "13 min continuous easy",
            "s": 1,
            "min": 13,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run",
        "blocks": [
          {
            "n": "26 min continuous easy",
            "s": 1,
            "min": 26,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "14": [
      {
        "title": "Tempo",
        "blocks": [
          {
            "n": "Easy running",
            "s": 1,
            "min": 8,
            "c": ""
          },
          {
            "n": "6 min tempo / 3 min jog",
            "s": 2,
            "min": 9,
            "c": "Comfortably hard: sustainable, not comfortable."
          },
          {
            "n": "Easy running",
            "s": 1,
            "min": 4,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Short easy run",
        "blocks": [
          {
            "n": "13 min continuous easy",
            "s": 1,
            "min": 13,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run",
        "blocks": [
          {
            "n": "28 min continuous easy",
            "s": 1,
            "min": 28,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "15": [
      {
        "title": "Intervals",
        "blocks": [
          {
            "n": "Easy running",
            "s": 1,
            "min": 8,
            "c": ""
          },
          {
            "n": "400m hard / 400m jog",
            "s": 5,
            "min": 4,
            "c": "Even pace across all five. Start slower than feels right."
          },
          {
            "n": "Easy running",
            "s": 1,
            "min": 2,
            "c": ""
          }
        ],
        "note": "Full recovery between reps. A speed session, not a suffering session."
      },
      {
        "title": "Short easy run",
        "blocks": [
          {
            "n": "13 min continuous easy",
            "s": 1,
            "min": 13,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Long easy run",
        "blocks": [
          {
            "n": "30 min continuous easy",
            "s": 1,
            "min": 30,
            "c": ""
          }
        ],
        "note": "Conversational pace. If you cannot speak a full sentence, slow down."
      }
    ],
    "16": [
      {
        "title": "Taper shakeout",
        "blocks": [
          {
            "n": "Easy running",
            "s": 1,
            "min": 14,
            "c": ""
          },
          {
            "n": "20s stride / 60s walk",
            "s": 4,
            "min": 0.33,
            "c": ""
          }
        ],
        "note": "Light. Saturday is the finish line."
      },
      {
        "title": "Short easy run",
        "blocks": [
          {
            "n": "10 min continuous easy",
            "s": 1,
            "min": 10,
            "c": ""
          }
        ],
        "note": ""
      },
      {
        "title": "Final test",
        "blocks": [
          {
            "n": "Easy jog warm-up",
            "s": 1,
            "min": 6,
            "c": "Then 4 strides of 20 seconds."
          },
          {
            "n": "TEST: timed 5km",
            "s": 1,
            "min": 33,
            "c": "Beat your week 12 distance. Then weigh and measure on Sunday."
          }
        ],
        "note": "Take it fresh."
      }
    ]
  },
  "food": {
    "breakfast": [
      {
        "n": "Greek yoghurt power bowl",
        "k": 397,
        "p": 32.5,
        "f": 10.2,
        "c": 41.6,
        "t": "3 min",
        "d": "250g 0% Greek yoghurt, 25g oats, 100g blueberries, 14g almonds, 6g honey."
      },
      {
        "n": "Salmon scramble on rye",
        "k": 422,
        "p": 34.3,
        "f": 22,
        "c": 17.6,
        "t": "8 min",
        "d": "3 eggs (150g), 50g smoked salmon, 80g spinach, 35g rye bread, 5ml olive oil, 1-cal spray for the pan."
      },
      {
        "n": "Protein oats",
        "k": 405,
        "p": 35,
        "f": 5.5,
        "c": 53.5,
        "t": "5 min",
        "d": "45g oats, 250g skimmed milk, 25g whey powder, 60g banana, cinnamon."
      },
      {
        "n": "Cottage cheese and eggs on toast",
        "k": 435,
        "p": 35.2,
        "f": 20.9,
        "c": 25,
        "t": "7 min",
        "d": "2 eggs (100g), 140g cottage cheese, 42g wholemeal bread, 100g tomatoes, 5ml olive oil, chives."
      },
      {
        "n": "Feta and mushroom omelette",
        "k": 445,
        "p": 31.3,
        "f": 25.6,
        "c": 17.2,
        "t": "10 min",
        "d": "3 eggs (150g), 25g feta, 100g mushrooms, 80g spinach, 35g wholemeal bread, 5ml olive oil."
      }
    ],
    "am": [
      {
        "n": "Yoghurt, raspberries and seeds",
        "k": 200,
        "p": 24,
        "f": 4.6,
        "c": 11.6,
        "t": "1 min",
        "d": "200g 0% Greek yoghurt, 80g raspberries, 8g pumpkin seeds."
      },
      {
        "n": "Shake and an apple",
        "k": 225,
        "p": 22.1,
        "f": 6,
        "c": 20.4,
        "t": "1 min",
        "d": "25g whey powder, 150g apple, 8g almonds, whey in 300ml water."
      },
      {
        "n": "Eggs, satsuma and almonds",
        "k": 178,
        "p": 13.2,
        "f": 9.6,
        "c": 8.4,
        "t": "prep ahead",
        "d": "2 eggs (100g), 70g satsuma, eggs boiled on Sunday."
      },
      {
        "n": "Biltong and a pear",
        "k": 196,
        "p": 16.3,
        "f": 3.8,
        "c": 22.7,
        "t": "0 min",
        "d": "30g biltong, 170g pear."
      },
      {
        "n": "Skyr and strawberries",
        "k": 200,
        "p": 21.5,
        "f": 5.9,
        "c": 13.3,
        "t": "1 min",
        "d": "170g skyr, 100g strawberries, 10g almonds."
      },
      {
        "n": "Cottage cheese on rye crackers",
        "k": 195,
        "p": 17.9,
        "f": 5.3,
        "c": 19.6,
        "t": "2 min",
        "d": "120g cottage cheese, 20g rye crackers, 60g tomatoes, cracked pepper."
      }
    ],
    "lunch": [
      {
        "n": "Chicken and couscous bowl",
        "k": 492,
        "p": 46.2,
        "f": 11.9,
        "c": 49,
        "t": "15 min",
        "d": "155g chicken breast, 55g dry couscous, 100g peppers, 80g courgette, 10ml olive oil, lemon."
      },
      {
        "n": "Tuna and butter bean salad",
        "k": 519,
        "p": 45.6,
        "f": 18.6,
        "c": 37.1,
        "t": "8 min",
        "d": "125g tuna in spring water, drained, 130g butter beans, 100g tomatoes, 40g rocket, 55g avocado, 35g wholemeal bread, 8ml olive oil, red onion, red wine vinegar."
      },
      {
        "n": "Prawn rice bowl",
        "k": 486,
        "p": 41.3,
        "f": 11.6,
        "c": 52.3,
        "t": "15 min",
        "d": "170g king prawns, 160g cooked basmati, 150g mixed stir-fry veg, 10ml sesame oil, reduced-salt soy sauce."
      },
      {
        "n": "Turkey and hummus wrap",
        "k": 516,
        "p": 43.4,
        "f": 20.2,
        "c": 37.3,
        "t": "5 min",
        "d": "60g wholemeal wrap, 135g turkey breast, 45g hummus, 60g mixed salad, 35g avocado, mustard."
      },
      {
        "n": "Hot-smoked salmon potato salad",
        "k": 526,
        "p": 39.5,
        "f": 20.2,
        "c": 46.3,
        "t": "12 min",
        "d": "115g hot-smoked salmon, 230g new potatoes, 100g green beans, 60g 0% Greek yoghurt, 5ml olive oil, mustard and dill."
      },
      {
        "n": "Turkey chilli, second portion",
        "k": 532,
        "p": 35.3,
        "f": 17.1,
        "c": 53.7,
        "t": "5 min",
        "d": "95g 5% turkey mince, 85g kidney beans, 100g chopped tomatoes, 125g cooked basmati, 30g 0% Greek yoghurt, 45g avocado, 5ml olive oil, the other half of the batch dinner."
      }
    ],
    "pm": [
      {
        "n": "Cottage cheese and oatcakes",
        "k": 213,
        "p": 17.4,
        "f": 8.5,
        "c": 17,
        "t": "1 min",
        "d": "120g cottage cheese, 20g oatcakes, 60g cucumber."
      },
      {
        "n": "Shake and almonds",
        "k": 190,
        "p": 23.1,
        "f": 9.4,
        "c": 2.8,
        "t": "1 min",
        "d": "25g whey powder, 15g almonds, whey in 300ml water."
      },
      {
        "n": "Tuna and rye crackers",
        "k": 228,
        "p": 23.7,
        "f": 6.5,
        "c": 17.7,
        "t": "2 min",
        "d": "80g tuna in spring water, drained, 20g rye crackers, 60g peppers, 35g avocado, lemon."
      },
      {
        "n": "Salted edamame",
        "k": 231,
        "p": 18.9,
        "f": 12.3,
        "c": 13.1,
        "t": "3 min",
        "d": "140g edamame, 10g almonds, chilli flakes, no added salt."
      },
      {
        "n": "Chicken and an apple",
        "k": 235,
        "p": 24.2,
        "f": 6.7,
        "c": 18.5,
        "t": "0 min",
        "d": "90g chicken breast, 150g apple, 10g almonds, chicken cooked ahead."
      },
      {
        "n": "Skyr and dark chocolate",
        "k": 198,
        "p": 18.4,
        "f": 6.1,
        "c": 14.6,
        "t": "1 min",
        "d": "150g skyr, 100g strawberries, 12g 85% dark chocolate."
      }
    ],
    "dinner": [
      {
        "n": "Sirloin and sweet potato wedges",
        "k": 563,
        "p": 41.9,
        "f": 18.5,
        "c": 53.2,
        "t": "20 min",
        "d": "155g lean sirloin, 225g sweet potato, 150g broccoli, 10ml olive oil."
      },
      {
        "n": "Salmon, quinoa and tenderstem",
        "k": 573,
        "p": 40,
        "f": 26,
        "c": 41.6,
        "t": "18 min",
        "d": "135g salmon fillet, 160g cooked quinoa, 200g tenderstem, 5ml olive oil, lemon."
      },
      {
        "n": "Chicken noodle stir-fry",
        "k": 573,
        "p": 49.1,
        "f": 17,
        "c": 53.8,
        "t": "15 min",
        "d": "155g chicken breast, 175g cooked egg noodles, 200g mixed stir-fry veg, 12ml sesame oil, ginger, garlic, reduced-salt soy."
      },
      {
        "n": "Turkey chilli",
        "k": 593,
        "p": 49.2,
        "f": 16.7,
        "c": 55.5,
        "t": "20 min",
        "d": "160g 5% turkey mince, 130g kidney beans, 200g chopped tomatoes, 100g cooked basmati, 8ml olive oil, cumin and smoked paprika. Cook double, the other half is tomorrow's lunch."
      },
      {
        "n": "Cod, chorizo and chickpeas",
        "k": 569,
        "p": 51.8,
        "f": 22,
        "c": 38.6,
        "t": "20 min",
        "d": "180g cod loin, 25g chorizo, 170g chickpeas, 150g peppers, 8ml olive oil."
      },
      {
        "n": "Prawn arrabbiata",
        "k": 561,
        "p": 48.1,
        "f": 14.9,
        "c": 59.5,
        "t": "18 min",
        "d": "175g king prawns, 75g dry wholewheat pasta, 200g passata, 12ml olive oil, chilli and garlic."
      },
      {
        "n": "Pork loin and roast squash",
        "k": 558,
        "p": 44.5,
        "f": 24.5,
        "c": 37.7,
        "t": "20 min",
        "d": "170g pork loin, 280g butternut squash, 150g green beans, 55g half-fat creme fraiche, 8ml olive oil, wholegrain mustard."
      }
    ],
    "post": [
      {
        "n": "Whey and a banana",
        "k": 196,
        "p": 21.2,
        "f": 1.8,
        "c": 24,
        "t": "1 min",
        "d": "25g whey powder, 110g banana, within an hour of finishing."
      },
      {
        "n": "Yoghurt, honey and blueberries",
        "k": 190,
        "p": 21.1,
        "f": 0.6,
        "c": 25.4,
        "t": "1 min",
        "d": "200g 0% Greek yoghurt, 12g honey, 70g blueberries."
      },
      {
        "n": "Whey stirred into oats",
        "k": 218,
        "p": 24.4,
        "f": 3.5,
        "c": 22.4,
        "t": "3 min",
        "d": "22g whey powder, 26g oats, 100g skimmed milk."
      }
    ]
  },
  "recovery": {
    "wed": {
      "name": "Recovery walk and mobility",
      "focus": "Not a rest day. Walking is where a real slice of the deficit comes from, and it costs you nothing in recovery.",
      "ex": [
        {
          "n": "Brisk walk",
          "s": 1,
          "r": "35-45 min",
          "c": "Outside, moderate pace."
        },
        {
          "n": "Calf and soleus stretch",
          "s": 2,
          "r": "45s each side",
          "c": "Straight leg, then bent knee. Both, every week."
        },
        {
          "n": "Hip flexor stretch",
          "s": 2,
          "r": "45s each side",
          "c": "Half-kneeling, squeeze the back glute."
        },
        {
          "n": "90/90 hip rotations",
          "s": 2,
          "r": "8 each side",
          "c": "Slow and controlled."
        },
        {
          "n": "Cat-cow",
          "s": 1,
          "r": "10 reps",
          "c": "Loosens the lower back after Monday."
        },
        {
          "n": "Hit 9,000 steps",
          "s": 1,
          "r": "",
          "c": "Tick at bedtime."
        }
      ]
    },
    "sun": {
      "name": "Recovery, weigh and reset",
      "focus": "Walk, weigh, shop, prep. Sunday is what makes the week possible.",
      "ex": [
        {
          "n": "Long easy walk",
          "s": 1,
          "r": "45-60 min",
          "c": "With Ozzie if he is up for it."
        },
        {
          "n": "Weigh in and log it",
          "s": 1,
          "r": "",
          "c": "Same conditions. Progress tab."
        },
        {
          "n": "Mobility circuit",
          "s": 2,
          "r": "rounds",
          "c": "Calves, hamstrings, hip flexors, thoracic rotations. 45 seconds each."
        },
        {
          "n": "Shop and prep for the week",
          "s": 1,
          "r": "",
          "c": "Standing list is in the Food tab."
        },
        {
          "n": "Hit 9,000 steps",
          "s": 1,
          "r": "",
          "c": ""
        }
      ]
    }
  },
  "gates": [
    {
      "lvl": 1,
      "week": 4,
      "name": "Level 1 - Foundation",
      "opens": "Level 2 - Build",
      "why": "Four weeks of turning up, not four weeks of trying hard. Nothing here asks you to be strong yet, and nothing here asks you to add weight, because block 1 explicitly tells you not to.",
      "crit": [
        {
          "t": "Completed 8 of the 8 lifting sessions, or 7 plus the missed one made up"
        },
        {
          "t": "Completed at least 10 of the 12 runs"
        },
        {
          "t": "Ran 3 minutes continuously in the week 4 test"
        },
        {
          "t": "Logged 3 or more weigh-ins in each of the last two weeks"
        },
        {
          "t": "7-day mean weight at or under 76.4kg",
          "auto": 76.4
        }
      ]
    },
    {
      "lvl": 2,
      "week": 8,
      "name": "Level 2 - Build",
      "opens": "Level 3 - Load",
      "why": "You have a base. This gate checks the base is real before the loading gets heavy and the running gets fast.",
      "crit": [
        {
          "t": "Ran 11 minutes continuously in the week 8 test"
        },
        {
          "t": "Hack squat or leg press up 10% or more since week 5 (four exposures at 2.5-5kg a time)"
        },
        {
          "t": "Dumbbell bench up 2.5kg per hand since week 5, or two more reps at the same weight"
        },
        {
          "t": "Pull-up assistance reduced, or one more rep at the same setting"
        },
        {
          "t": "7-day mean weight at or under 75.4kg",
          "auto": 75.4
        }
      ]
    },
    {
      "lvl": 3,
      "week": 12,
      "name": "Level 3 - Load",
      "opens": "Level 4 - Sharpen",
      "why": "Thirty unbroken minutes and a hinge you can load. Level 4 only makes sense if both are genuinely there.",
      "crit": [
        {
          "t": "Ran 30 minutes continuously in the week 12 test, distance logged"
        },
        {
          "t": "Trap-bar 4 sets of 5 at full working load in weeks 11 and 12, no back symptoms"
        },
        {
          "t": "Seated calf raise load up since week 5"
        },
        {
          "t": "Waist down 3cm or more from the week 1 measurement"
        },
        {
          "t": "7-day mean weight at or under 74.3kg",
          "auto": 74.3
        }
      ]
    },
    {
      "lvl": 4,
      "week": 16,
      "name": "Level 4 - Sharpen",
      "opens": "Finished",
      "why": "The finish line is 4.5kg of fat gone with your lean mass intact. The scale alone cannot tell you whether you managed it, which is why the waist and the lifting numbers are in here too.",
      "crit": [
        {
          "t": "Timed 5km completed, faster per kilometre than the week 12 test"
        },
        {
          "t": "Waist down 5cm or more from the week 1 measurement"
        },
        {
          "t": "Working weights at or above their week 13 figures on bench, row and leg press"
        },
        {
          "t": "Next block booked - maintenance, or a proper strength phase"
        },
        {
          "t": "7-day mean weight at or under 73.5kg",
          "auto": 73.5
        }
      ]
    }
  ],
  "rules": [
    [
      "Why This Block Has an End Date",
      "You are eating in a deficit and running three times a week. Those two demands work against each other, and the plan accepts that deliberately.\n\nEnergy availability is the energy left to run your body once training has taken its share, measured per kilo of lean mass. Below about 30 the body starts cutting back on things you would rather keep. The difficulty is that you cannot stay above 30 while losing fat: at your lean mass that would take roughly 2,650 kcal a day, which is more than you burn.\n\nSo the plan holds energy availability above 20 in every week and finishes at week 16 rather than running indefinitely. That is why the block has an end date."
    ],
    [
      "When to Add Weight",
      "When you hit the top of the rep range on every set with clean form, add weight in the next session: 2.5kg on the big lifts, 1-2kg on the small ones.\n\nIf you miss your target reps in two consecutive sessions, you have gone too heavy. Drop the load by 10% and build back up.\n\nBlock 1 is the exception. It asks you to leave three reps in the tank, and the week 4 checkpoint does not ask for any added load, so there is nothing to gain by pushing early."
    ],
    [
      "The Lower-Back Rules",
      "Five movements are excluded for all 16 weeks: conventional deadlift from the floor, loaded sit-ups, Russian twists, good mornings, and standing overhead press.\n\nThe trap-bar deadlift is the only loaded hinge in the plan and it starts late, at roughly 60% in week 9 and reaching full working load in week 11.\n\nLeg press has a depth stop. Stop about 10 degrees short of the point where your pelvis begins to tuck under. That tuck is loaded lumbar flexion, which is the specific thing this plan is built to avoid."
    ],
    [
      "What to Do About a Back Symptom",
      "A flare-up is information rather than a penalty, and it is deliberately not a checkpoint criterion. Making it one would encourage you to under-report the most important signal you have.\n\nAct if pain centralises, pain radiates, or stiffness is still present 30 minutes after you get up.\n\nReduce the hinge load by 20% and ramp back up over two weeks. Replace the trap-bar with hip thrusts and back extensions in the meantime, and carry on training everything else.\n\nIf it has not settled within two weeks, see a physiotherapist. That is beyond what this plan can tell you."
    ],
    [
      "Easy Runs Should Feel Easy",
      "If you cannot hold a full sentence while running, you are going too fast.\n\nTwo of your three weekly runs are easy by design and stay easy even in the faster blocks. Most of the fat loss and almost all of the durability you build come from running at that pace."
    ],
    [
      "Why Three Runs and Not Two",
      "Running twice a week means every increase in weekly volume has to arrive as one large jump within a single session. Large single-session jumps are the main injury mechanism for runners returning in their fifties.\n\nThree runs spread the same volume across more sessions. The third run is short and easy on purpose; it is there for frequency rather than fitness."
    ],
    [
      "Missed Runs",
      "If you miss one run, do it when you can and then carry on with the schedule. Never run twice in one day to catch up.\n\nIf you miss a whole week, repeat that week rather than skipping ahead.\n\nDo not compensate for a missed easy run by making the next hard run harder."
    ],
    [
      "De-Loads",
      "Weeks 4, 8, 12 and 16 are deliberately lighter. Lifting drops one set per exercise at the same weight, running volume falls by roughly a quarter, and the level test sits at the end of the week so that you arrive rested.\n\nA test taken while fatigued measures your fatigue rather than your fitness."
    ],
    [
      "Steer With Your Own Data",
      "Maintenance is the daily intake at which your weight holds steady. Yours is estimated at about 2,400 kcal, and that estimate could be 200 kcal out in either direction. Across 16 weeks that difference decides whether you finish at 70kg or 75kg, so it is worth correcting with your own measurements rather than trusting the estimate.\n\nEat the plan for three full weeks. Then open Progress and compare your 7-day mean weight against the trajectory, which is the line showing the weight the plan expects you to reach in each week.\n\nIf you are lighter than the line you are losing faster than planned, so add 100 kcal a day. If you are heavier than the line by more than 0.5kg you are losing too slowly, so take 100 kcal off.\n\nRepeat the comparison every third week."
    ],
    [
      "When the Scale Stops Moving",
      "If your 7-day mean has not moved for two consecutive weeks at any point after week 5, do not cut your calories yet.\n\nSpend a week checking your food logging first. Weigh everything, including cooking oil and weekend meals. Most stalls turn out to be tracking that has drifted rather than a body that has stopped responding.\n\nIf the logging was accurate and the mean still has not moved, increase your intake for one week by about 350 kcal a day. That takes you from the plan's usual 2,033 to roughly 2,400, which is maintenance. Return to the plan afterwards.\n\nEating more in order to resume fat loss is counterintuitive, so here is the reasoning. You are already eating well below what you burn while training five days a week. Cutting further costs you strength, recovery and muscle before it costs you fat, and muscle is what this block is built to protect."
    ],
    [
      "Losing Weight Too Quickly",
      "If your 7-day mean falls by more than 0.6kg a week for two consecutive weeks, add 150 kcal a day back.\n\nAt that rate you are losing lean mass alongside fat, and this block needs your lean mass to rise by about 0.2kg rather than merely hold. Losing weight quickly and losing fat well are not the same outcome.\n\nWeeks 1 and 2 are exempt. The early drop is mostly water and glycogen, and it tells you nothing about fat loss."
    ],
    [
      "Eating Out and Alcohol",
      "You have one flexible meal a week. Take it on a training day, and order your protein and vegetables before anything else. Filling up on those first does more than relying on restraint later.\n\nAlcohol: up to three drinks a week, roughly 400 kcal. Take that out of the same day's dinner starch and afternoon snack combined. It has to come from both, because no single dinner in the rotation holds 400 kcal of carbohydrate to remove.\n\nDo not drink the night before a Saturday run or a level test."
    ],
    [
      "Vitamin D",
      "Take 10 micrograms (400 IU) a day from October to April.\n\nThis block runs from late August to late December at UK latitude, where your skin produces almost none for most of that period. Every other supplement in this plan is optional. This one is not."
    ],
    [
      "Salt",
      "The meal rotation is high in salt, mainly through the biltong, chorizo, smoked salmon, deli turkey and soy sauce.\n\nUse reduced-salt soy sauce, skip the added salt on the edamame, rinse tinned pulses before using them, and keep cured items to one a day."
    ],
    [
      "How to Weigh Yourself",
      "Weigh yourself three or four mornings a week, first thing, after the toilet and before food or water. Keep the conditions the same each time.\n\nRead the 7-day mean rather than any single reading. One morning can vary by up to 1.5kg on salt and glycogen alone, so individual figures tell you very little.\n\nThe checkpoints in this app read the mean, not your lowest recorded weight."
    ],
    [
      "Waist Measurements",
      "Measure your waist at the navel, first thing in the morning, in week 1 and then every fourth Sunday.\n\nTake the week 1 measurement before you start training. Two of the four checkpoints compare against it, and it cannot be recovered later.\n\nWaist measurements often keep falling during weeks when the scale does not move, which makes the tape a useful second reading during a stall."
    ],
    [
      "Sleep",
      "Sleeping under seven hours makes hunger harder to manage and lifting measurably worse.\n\nIf your sleep has been disrupted for a week, hold your calories where they are rather than cutting further."
    ],
    [
      "Missing a Checkpoint",
      "You get up to two hold weeks. A hold repeats the last build week of the block rather than the test week, because retaking a maximal test every week builds nothing.\n\nAfter two holds the plan advances regardless, with that level's working loads set 10% lower.\n\nMost people miss at least one checkpoint, and the plan is designed on that assumption."
    ]
  ],
  "runWarmUp": {
    "n": "Brisk walk warm-up",
    "s": 1,
    "r": "5 min",
    "c": "Ankles, calves and hips. Not optional at 51."
  },
  "runCoolDown": {
    "n": "Walk cool-down",
    "s": 1,
    "r": "5 min",
    "c": "Then calf and hip-flexor stretch, 45 seconds each."
  }
}